import { jsxs, jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "react";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import { styled } from "@mui/material";
import { PenSolid as e } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/pen-solid.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import { useDropzone } from "../../../node_modules/react-dropzone/dist/es/index.es.js";
import { Avatar } from "./avatar.es.js";
import { AvatarProgressBar } from "./avatar-progress-bar.es.js";
import { Positioning } from "../../foundations/positioning.es.js";
import Box from "../../../node_modules/@mui/material/Box/Box.es.js";
import Badge from "../../../node_modules/@mui/material/Badge/Badge.es.js";
import { Displaying } from "../../foundations/displaying.es.js";
import { Alignment } from "../../foundations/alignment.es.js";
import { CursorStyle } from "../../foundations/cursor-style.es.js";
import { Direction } from "../../foundations/direction.es.js";
const AVATAR_STEPPER_SIZE = "3.625rem";
const AVATAR_STEPPER_ICON_SIZE = "4.375rem";
const AVATAR_STEPPER_BADGE_ICON_SIZE = "0.469rem";
function AvatarStepper({
  numberBarCompleted,
  id,
  avatarProps,
  label,
  handleProfileImageUpdate,
  children
}) {
  const {
    getRootProps,
    getInputProps
  } = useDropzone({
    onDrop: handleProfileImageUpdate,
    maxFiles: 1,
    accept: {
      "image/*": []
    }
  });
  return /* @__PURE__ */ jsxs(AvatarStepperContainer, { id, children: [
    /* @__PURE__ */ jsxs(Box, { position: Positioning.relative, display: Displaying.flex, alignItems: Alignment.center, justifyContent: Alignment.center, children: [
      /* @__PURE__ */ jsx(AvatarProgressBar, { numberBarCompleted }),
      /* @__PURE__ */ jsxs(AvatarContainer, { ...getRootProps(), children: [
        /* @__PURE__ */ jsx("input", { ...getInputProps() }),
        /* @__PURE__ */ jsx(StyledBadge, { overlap: "circular", badgeContent: /* @__PURE__ */ jsx(e, {}), anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        }, children: /* @__PURE__ */ jsx(StyledAvatar, { ...avatarProps, children }) })
      ] })
    ] }),
    label
  ] });
}
const StyledBadge = styled(Badge)(({
  theme
}) => ({
  ".MuiBadge-overlapCircular": {
    border: `1px solid ${theme.palette.primary.main}`,
    height: theme.spacing(3),
    width: theme.spacing(3),
    minWidth: theme.spacing(3),
    padding: theme.spacing(0),
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.common.white
  },
  ".MuiSvgIcon-root": {
    width: AVATAR_STEPPER_BADGE_ICON_SIZE,
    height: AVATAR_STEPPER_BADGE_ICON_SIZE
  }
}));
const StyledAvatar = styled(Avatar)(({
  theme
}) => ({
  width: AVATAR_STEPPER_SIZE,
  height: AVATAR_STEPPER_SIZE,
  backgroundColor: theme.palette.common.white,
  color: theme.palette.primary.main,
  ".MuiSvgIcon-root": {
    width: AVATAR_STEPPER_ICON_SIZE,
    height: AVATAR_STEPPER_ICON_SIZE
  },
  "&:hover": {
    cursor: CursorStyle.pointer
  }
}));
const AvatarContainer = styled(Box)(({
  theme
}) => ({
  position: Positioning.absolute,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  paddingTop: theme.spacing(2),
  height: AVATAR_STEPPER_SIZE,
  width: AVATAR_STEPPER_SIZE
}));
const AvatarStepperContainer = styled(Box)(({
  theme
}) => ({
  display: Displaying.flex,
  flexDirection: Direction.row,
  alignItems: Alignment.center,
  gap: theme.spacing(3)
}));
export {
  AvatarStepper
};
//# sourceMappingURL=avatar-stepper.es.js.map
